function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="116" height="72" viewBox="0 0 116 72" {...props}><path fill="#EB001B" d="M44 36c0-11.595 5.487-21.902 14-28.486A35.834 35.834 0 0 0 36 0C16.118 0 0 16.118 0 36s16.118 36 36 36a35.834 35.834 0 0 0 22-7.514C49.487 57.902 44 47.595 44 36z" /><path fill="#F79E1B" d="M80 0a35.834 35.834 0 0 0-22 7.514C66.513 14.098 72 24.405 72 36s-5.487 21.902-14 28.486A35.834 35.834 0 0 0 80 72c19.882 0 36-16.118 36-36S99.882 0 80 0z" /><ellipse fill="#FF5F00" cx="58" cy="36" rx="14" ry="28.486" /></svg>;
});